import React from 'react';
import { PetAvatar } from '@/components/PetAvatar';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      const petType = localStorage.getItem('you_pet_type') || 'elephant';
      const petName = localStorage.getItem('you_pet_name') || 'your pet';
      return (
        <div
          style={{
            position: 'fixed', inset: 0, zIndex: 9998,
            background: 'rgba(10,10,30,0.6)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: 20,
          }}
        >
          <div style={{
            background: '#FFFEF9', borderRadius: 4, maxWidth: 320, width: '100%',
            padding: '28px 20px', textAlign: 'center',
            border: '1.5px dashed #CCCCCC', borderLeft: '3px solid #FF6B6B',
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12,
          }}>
            <PetAvatar pet={petType} mood="thinking" size={100} />
            <p style={{ fontFamily: "'Patrick Hand', cursive", fontSize: 22, color: '#1A1A2E', margin: 0 }}>
              {petName} had a little stumble!
            </p>
            <p style={{ fontSize: 16, color: '#333333', margin: 0, lineHeight: 1.5 }}>
              {this.props.fallbackMessage || "Don't worry, let's try again!"}
            </p>
            <button
              onClick={() => this.setState({ hasError: false })}
              aria-label="Try again"
              style={{
                marginTop: 4, background: '#448AFF', color: '#fff',
                border: 'none', borderRadius: 14, padding: '14px 28px',
                fontFamily: "'Patrick Hand', cursive", fontSize: 18, cursor: 'pointer',
              }}
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
